import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { PlayStagedAnimationsInteractivityActionSnapshotOut } from '../play-staged-animations/PlayStagedAnimationsInteractivityAction';
import type { ShowElementsInteractivityActionSnapshotOut } from './ShowElementsInteractivityAction';

export const showElementsInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.ShowElements,

  innerInteractivityActions: {
    fromSnapshot(sn: ShowElementsInteractivityActionSnapshotOut) {
      const { stagedAnimations, stagedAnimationsIfVisible } = sn;

      return [stagedAnimations, stagedAnimationsIfVisible].filter(
        iA => iA,
      ) as PlayStagedAnimationsInteractivityActionSnapshotOut[];
    },
  },
};
